import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gpt-settings" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "gpt-settings mt-2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "GPT Settings:")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_InputText, {
      class: "mt-2",
      label: "Model",
      value: _ctx.value.model,
      placeholder: 'gpt-3.5-turbo-0301',
      "onUpdate:value": _cache[0] || (_cache[0] = val => _ctx.$emit('update:value', {..._ctx.value, model: val} ))
    }, null, 8, ["value", "placeholder"]),
    _createVNode(_component_InputText, {
      class: "mt-2",
      label: "Max Tokens",
      value: _ctx.value.max_tokens,
      placeholder: '2000',
      "onUpdate:value": _cache[1] || (_cache[1] = val => _ctx.$emit('update:value', {..._ctx.value, max_tokens: +val} ))
    }, null, 8, ["value"]),
    _createVNode(_component_InputText, {
      class: "mt-2",
      label: "Temperature",
      value: _ctx.value.temperature,
      placeholder: '0',
      "onUpdate:value": _cache[2] || (_cache[2] = val => _ctx.$emit('update:value', {..._ctx.value, temperature: +val} ))
    }, null, 8, ["value"]),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setToDefault && _ctx.setToDefault(...args))),
      class: "underline mt-2"
    }, "Set to default")
  ]))
}